let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;

  setTimeout(function () {

  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-cart-drawer.css?v=65721217805242129141770108239");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/review.css?v=25384460974739800321770108275");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/swiper-bundle.css?v=183092761113033764571770108285");
  //loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-rating.css?v=24573085263941240431770108248");
  
  //Dynamically load JavaScript files  
  loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/Product-Compare-image.js?v=107442799752783528591770108269");
  loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/review.js?v=179122652022389052751770108276");
  loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/swiper-bundle.js?v=30986975797822707101770108286");
  //loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/marquee.js?v=149530619952598007711770108265");
  //loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/marquee.js?v=149530619952598007711770108265");
  //loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/marquee.js?v=149530619952598007711770108265");
  //loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/marquee.js?v=149530619952598007711770108265");
  //loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/cart-notification.js?v=160453272920806432391770108234");
  loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/quick-add.js?v=21087258723263848871770108272");
  loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/search-form.js?v=113639710312857635801770108277");
  loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/predictive-search.js?v=21556096761500878031770108268");
  loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/product-form.js?v=61273411803440067421770108269");
  loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/details-disclosure.js?v=153497636716254413831770108254");
  loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/details-modal.js?v=4511761896672669691770108254");
  loadScript("//moxiebeauty.in/cdn/shop/t/112/assets/pubsub.js?v=2921868252632587581770108271");
  
  

  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/section-footer.css?v=171161867995400310821770108280");
  //loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-newsletter.css?v=103472482056003053551770108246");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/sr-checkout-styles.css?v=93922634311318349371770108284");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-cart.css?v=61086454150987525971770108240");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-cart-items.css?v=73357622004024540021770108239");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-cart-notification.css?v=108833082844665799571770108240");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-discounts.css?v=152760482443307489271770108241");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-totals.css?v=86168756436424464851770108250");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-list-payment.css?v=69253961410771838501770108243");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-list-social.css?v=52211663153726659061770108244");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-list-menu.css?v=151968516119678728991770108243");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-search.css?v=110505427807447362961770108249");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-predictive-search.css?v=68801219296741410351770108247");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/before.css?v=27895467328548674691770108232");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/Product-Compare-image.css?v=138661879954047130511770108269");
  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/before.css?v=27895467328548674691770108232");


  loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-loading-overlay.css?v=167310470843593579841770108244");
  // loadCSS("//moxiebeauty.in/cdn/shop/t/112/assets/component-card.css?v=168685987607774519451770108238");

  // Load the font
  loadFont();

  loadScriptWithDelay("//moxiebeauty.in/cdn/shop/t/112/assets/app.js?v=30176248763157843031770108231", 200);
  }, 10);

  // Clean up event listeners (if needed)
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

// Check if the user is beyond 400px from the top
if (window.scrollY >= 400) {
  loadScripts(); // Load immediately if user is already past 400px
} else {
  // Wait for user interaction
  document.addEventListener('mouseover', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

// Helper function to dynamically load a JavaScript file
function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.defer = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadScriptWithDelay(src, delay) {
  setTimeout(() => {
    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  }, delay);
}

// Helper function to dynamically load a CSS file
function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}


// Helper function to load the font dynamically
function loadFont() {
  var style = document.createElement('style');
  style.textContent = `
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-100.woff2?v=1692617651');
      font-weight: 100;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-200.woff2?v=1692617651');
      font-weight: 200;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-300.woff2?v=1692617651');
      font-weight: 300;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-400.woff2?v=1692617651');
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-500.woff2?v=1692617651');
      font-weight: 500;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-700.woff2?v=1692617651');
      font-weight: 700;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-800.woff2?v=1692617651');
      font-weight: 800;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-900.woff2?v=1692617651');
      font-weight: 900;
      font-style: normal;
      font-display: swap;
    }
  `;
  document.head.appendChild(style);
}
